import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18fae8e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "headlines" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "created" }, "Created"),
  /*#__PURE__*/_createElementVNode("div", { class: "closed" }, "Closed")
], -1))
const _hoisted_3 = {
  key: 0,
  class: "vertical-divider"
}
const _hoisted_4 = { class: "total-new" }
const _hoisted_5 = { class: "total-count" }
const _hoisted_6 = { class: "legend" }
const _hoisted_7 = { class: "legend-item" }
const _hoisted_8 = { class: "legend-item" }
const _hoisted_9 = { class: "legend-item" }
const _hoisted_10 = { class: "total-closed" }
const _hoisted_11 = { class: "total-count" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_progress_bar = _resolveComponent("ion-progress-bar")!
  const _component_DeviationClassificationIcon = _resolveComponent("DeviationClassificationIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: _normalizeClass(["bar", {'no-deviations': _ctx.noDeviationsInPeriod }])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["bar-column major", _ctx.state]),
        style: _normalizeStyle(_ctx.bar.majorStyle)
      }, null, 6),
      _createElementVNode("div", {
        class: _normalizeClass(["bar-column minor", _ctx.state]),
        style: _normalizeStyle(_ctx.bar.minorStyle)
      }, null, 6),
      _createElementVNode("div", {
        class: _normalizeClass(["bar-column unclassified", _ctx.state]),
        style: _normalizeStyle(_ctx.bar.unclassifiedStyle)
      }, null, 6),
      _createElementVNode("div", {
        class: _normalizeClass(["bar-column closed", _ctx.state]),
        style: _normalizeStyle(_ctx.bar.closedStyle)
      }, [
        (_ctx.bar.showDivider)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3))
          : _createCommentVNode("", true)
      ], 6),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (_ctx.state === 'loading')
            ? (_openBlock(), _createBlock(_component_ion_progress_bar, {
                key: 0,
                type: "indeterminate"
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["legend-summary", _ctx.state])
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.legend.totalOpen), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_DeviationClassificationIcon, {
            classification: _ctx.Classification.Major
          }, null, 8, ["classification"]),
          _createElementVNode("div", null, _toDisplayString(_ctx.legend.major), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_DeviationClassificationIcon, {
            classification: _ctx.Classification.Minor
          }, null, 8, ["classification"]),
          _createElementVNode("div", null, _toDisplayString(_ctx.legend.minor), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_DeviationClassificationIcon, {
            classification: _ctx.Classification.Unclassifed
          }, null, 8, ["classification"]),
          _createElementVNode("div", null, _toDisplayString(_ctx.legend.unclassified), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.legend.totalClosed), 1)
      ])
    ], 2)
  ]))
}